import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, Picker, List, Button, Modal, InputItem, Toast, ActionSheet } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import CommonUtils from '../utils/CommonUtils';
import { createForm } from 'rc-form';
import '../styles/SitePage.css';

const history = require("history").createHashHistory()

class SitePage extends Component {
    static defaultProps = {
        fetchDictionary: (dictType, callback) => {},
        fetchDistrict: (params, callback) => {},
        fetchSites: (params, callback) => {},
        createSite: (params, callback, completed) => {},
        updateSite: (params, callback, completed) => {},
        shutdownTime: (params, callback, completed) => {},
        delegateProfile: (params, callback) => {}
    }

    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            districtData: [],
            dictData: {},
            showCreateModal: false,
            enableCreate: true,
            showUpdateModal: false,
            enableUpdate: true,
            showConrolShutdownModal: false,
            enableControlShutdown: true,
            selectedItem: null,
            delegateProfile: null
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 80;
        this.setState({
            height
        })
        this.props.delegateProfile({}, (resp) => {
            this.setState({
                delegateProfile: resp.data
            })
        })
        this.loadDictData()
        this.loadSiteData(1)
        this.loadDistrictData()
    }

    loadSiteData = (pageNum) => {
        const params = {
            pageNum,
            pageSize: 10
        }
        this.props.fetchSites(params, (resp) => {
            let data = resp.data
            this.pageNum = data.pageNum;
            this.pageSize = data.pageSize;
            this.pages = data.pages;
            let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
            this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
            this.setState({
                dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                isLoading: false,
                hasMore: this.pageNum < this.pages,
            })
        })
    }

    loadDistrictData = () => {
        this.props.fetchDistrict({}, (resp) => {
            this.setState({
                districtData: resp.data
            })
        })
    }

    loadDictData = () => {
        this.props.fetchDictionary('SHUTDOWN_TIME', (resp) => {
            this.setState({
                dictData: resp.data
            })
        })
    }

    resolveShutdownTime = (shutdownTime) => {
        if(CommonUtils.isEmpty(shutdownTime)) {
            return '无'
        }

        const { dictData } = this.state
        if(!dictData['SHUTDOWN_TIME']) {
            return shutdownTime
        }

        for(let item of dictData['SHUTDOWN_TIME']) {
            if(item.itemCode === shutdownTime) {
                return item.itemName
            }
        }
        return shutdownTime
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadSiteData(++this.pageNum)
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    handleItemClick = (rowData) => {
        const { delegateProfile } = this.state
        const options = []
        if(!delegateProfile || delegateProfile.delegateType === 'OPERATOR') {
            options.push({ icon: <i className='iconfont icon-xiugai' style={{color:'#04bbc5', fontSize: 30}}/>, title: '编辑信息' })
            options.push({ icon: <i className='iconfont icon-guangbo-dingshi' style={{color:'orange', fontSize: 30}}/>, title: '定时关机' })
        }
        if(!options.length) {
            Toast.info('无操作权限')
            return
        }

        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }
        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: rowData.siteName,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '编辑信息') {
                this.setState({
                    showUpdateModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '定时关机') {
                this.setState({
                    showConrolShutdownModal: true,
                    selectedItem: rowData
                })
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    handleCreateClick = () => {
        this.setState({
            enableCreate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            const propPrefix = 'create_'
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf(propPrefix) !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableCreate: true
                        })
                        return
                    }
                }
            }

            const districtInfo = this.doResolveDistrictInfo(fieldsValue.create_district)
            const params = {
                provinceCode: districtInfo.province.value,
                provinceName: districtInfo.province.label,
                cityCode: districtInfo.city.value,
                cityName: districtInfo.city.label,
                countyCode: districtInfo.county.value,
                countyName: districtInfo.county.label,
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf(propPrefix) !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring(propPrefix.length)] = propValue               
            }

            this.props.createSite(params, (resp) => {
                this.setState({
                    showCreateModal: false
                })
                this.props.form.resetFields()
                this.loadSiteData(1)
            }, () => {
                this.setState({
                    enableCreate: true
                })
            })
        });
    }

    handleUpdateClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableUpdate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            const propPrefix = 'update_'
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf(propPrefix) !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableUpdate: true
                        })
                        return
                    }
                }
            }

            const districtInfo = this.doResolveDistrictInfo(fieldsValue.update_district)
            const params = {
                id: selectedItem.id,
                provinceCode: districtInfo.province.value,
                provinceName: districtInfo.province.label,
                cityCode: districtInfo.city.value,
                cityName: districtInfo.city.label,
                countyCode: districtInfo.county.value,
                countyName: districtInfo.county.label,
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf(propPrefix) !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring(propPrefix.length)] = propValue               
            }
            this.props.updateSite(params, (resp) => {
                this.setState({
                    showUpdateModal: false
                })
                this.props.form.resetFields()
                this.loadSiteData(1)
            }, () => {
                this.setState({
                    enableUpdate: true
                })
            })
        })
    }

    handleControlShutdownClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableControlShutdown: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            const propPrefix = 'shutdown_'
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf(propPrefix) !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableControlShutdown: true
                        })
                        return
                    }
                }
            }

            const params = {
                siteId: selectedItem.id
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf(propPrefix) !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring(propPrefix.length)] = propValue               
            }
            this.props.shutdownTime(params, (resp) => {
                this.setState({
                    showConrolShutdownModal: false
                })
                this.props.form.resetFields()
                this.loadSiteData(1)
            }, () => {
                this.setState({
                    enableControlShutdown: true
                })
            })
        })
    }

    doResolveDistrictInfo = (district) => {
        const { districtData } = this.state
        const provinceValue = district[0], cityValue = district[1], countyValue = district[2]
        let province={}, city={}, county={}
        
        districtData.forEach(item => {
            if(provinceValue === item.value) {
                province = item
                return
            }
        })
        if(province.children && cityValue) {
            province.children.forEach(item => {
                if(cityValue === item.value) {
                    city = item
                    return
                }
            })
        }
        if(city.children && countyValue) {
            city.children.forEach(item => {
                if(countyValue === item.value) {
                    county = item
                    return
                }
            })
        }
        return { province, city, county }
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {
        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleItemClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={rowData.siteName}
                            extra={<span>{rowData.createTime}</span>}
                        />
                        {CommonUtils.isNotEmpty(rowData.address) ? (
                            <Card.Body>
                                <div className='info-item word-ellipsis'>
                                    <span className='label'>行政区划：</span> 
                                    <span className='value'>{rowData.provinceName}{rowData.cityName}{rowData.countyName}</span>
                                </div>
                                <div className='info-item word-ellipsis'>
                                    <span className='label'>详细地址：</span> 
                                    <span className='value'>{rowData.address}</span>
                                </div>
                                <div className='info-item word-ellipsis'>
                                    <span className='label'>关闭充值：</span> 
                                    <span className='value'>{rowData.hideRecharge===1?'是':'否'}</span>
                                </div>
                                <div className='info-item word-ellipsis'>
                                    <span className='label'>定时关机：</span> 
                                    <span className='value'>{this.resolveShutdownTime(rowData.shutdownTime)}</span>
                                </div>
                            </Card.Body>) : (
                            <Card.Body>
                                <div className='no-data'>
                                    请完善门店信息！
                                </div>
                            </Card.Body>
                        )}
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderCreateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showCreateModal, enableCreate, districtData } = this.state
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showCreateModal}
                    onClose={() => {
                        this.setState({showCreateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>新建门店</div>}>
                        <InputItem {...getFieldProps('create_siteName', {
                            initialValue: '',
                            rules: [{required: true, message: '请填写门店名称'}],
                        })}>
                            门店名称
                        </InputItem>
                        <Picker 
                            cols={3}
                            data={districtData}
                            {...getFieldProps('create_district', {
                                rules: [{required: true, message: '请选择行政区划'}],
                            })} 
                            >
                            <List.Item arrow="horizontal">行政区划</List.Item>
                        </Picker>
                        <InputItem {...getFieldProps('create_address', {
                            initialValue: '',
                            rules: [{required: true, message: '请填写详细地址'}],
                        })}>
                            详细地址
                        </InputItem>
                        <Picker 
                            cols={1}
                            data={[{label:'否', value: 0}, {label: '是', value: 1}]}
                            {...getFieldProps('create_hideRecharge', {
                                initialValue: [0],
                                rules: [{required: true, message: '请选择是否关闭充值'}],
                            })} 
                        >
                            <List.Item arrow="horizontal">关闭充值</List.Item>
                        </Picker>
                        <List.Item>
                            <Button type="primary" onClick={this.handleCreateClick} disabled={!enableCreate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderUpdateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showUpdateModal, enableUpdate, districtData, selectedItem } = this.state
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showUpdateModal}
                    onClose={() => {
                        this.setState({showUpdateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>编辑门店</div>}>
                        <InputItem {...getFieldProps('update_siteName', {
                            initialValue: selectedItem?selectedItem.siteName:null,
                            rules: [{required: true, message: '请填写门店名称'}],
                        })}>
                            门店名称
                        </InputItem>
                        <Picker 
                            cols={3}
                            data={districtData}
                            {...getFieldProps('update_district', {
                                initialValue: selectedItem?[selectedItem.provinceCode, selectedItem.cityCode, selectedItem.countyCode]:[],
                                rules: [{required: true, message: '请选择行政区划'}],
                            })} 
                            >
                            <List.Item arrow="horizontal">行政区划</List.Item>
                        </Picker>
                        <InputItem {...getFieldProps('update_address', {
                            initialValue: selectedItem?selectedItem.address:null,
                            rules: [{required: true, message: '请填写详细地址'}],
                        })}>
                            详细地址
                        </InputItem>
                        <Picker 
                            cols={1}
                            data={[{label:'否', value: 0}, {label: '是', value: 1}]}
                            {...getFieldProps('update_hideRecharge', {
                                initialValue: selectedItem?[selectedItem.hideRecharge===1?selectedItem.hideRecharge:0]:[],
                                rules: [{required: true, message: '请选择是否关闭充值'}],
                            })} 
                        >
                            <List.Item arrow="horizontal">关闭充值</List.Item>
                        </Picker>
                        <List.Item>
                            <Button type="primary" onClick={this.handleUpdateClick} disabled={!enableUpdate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderControlShutdownModal = () => {
        const { getFieldProps } = this.props.form;
        const { showConrolShutdownModal, enableControlShutdown, selectedItem, dictData } = this.state
        const shutdownTimePickerData = dictData['SHUTDOWN_TIME'] ? dictData['SHUTDOWN_TIME'].map(item => ({label: item.itemName, value: item.itemCode})) : []
       
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showConrolShutdownModal}
                    onClose={() => {
                        this.setState({showConrolShutdownModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>定时关机</div>}>
                        <InputItem disabled {...getFieldProps('shutdown_siteName', {
                            initialValue: selectedItem?selectedItem.siteName:null,
                        })}>
                            门店名称
                        </InputItem>
                        <Picker 
                            cols={1}
                            data={[{label:'无', value:''}, ...shutdownTimePickerData]}
                            {...getFieldProps('shutdown_shutdownTime', {
                                initialValue: selectedItem&&selectedItem.shutdownTime?[selectedItem.shutdownTime]:[''],
                                rules: [{required: true, message: '请选择关机时间'}],
                            })} 
                            >
                            <List.Item arrow="horizontal">关机时间</List.Item>
                        </Picker>
                        <List.Item>
                            <Button type="primary" onClick={this.handleControlShutdownClick} disabled={!enableControlShutdown}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    render() {
        const {dataSource, isLoading, delegateProfile} = this.state;
        let rightContent
        if(!delegateProfile) {
            rightContent = <i className='iconfont icon-tianjia' style={{color:'black'}} onClick={() => {this.setState({showCreateModal: true})}}></i>
        }

        return (
            <div className='site-page'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                    rightContent={rightContent}
                >
                    门店管理
                </NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 50
                    }}
                />
                {this.doRenderCreateModal()}
                {this.doRenderUpdateModal()}
                {this.doRenderControlShutdownModal()}
            </div>
        )
    }
}

export default createForm()(SitePage);


// WEBPACK FOOTER //
// ./src/components/SitePage.js